<template lang="html">
  <div class="kids">
    <main>
      <h1>Your Kids</h1>
      <hr>
      <div class="kid-list">
        <KidsPreview
          v-for="kid of kids"
          :key="kid.id"
          :id="kid.id"
          :name="kid.name"
          :avatar="kid.avatar"/>

        <KidsNew />
      </div>

      <div class="kid-invite-container" v-if="showNewKid">
        <h1>Invite Your Kids</h1>
        <hr>
        <div class="kid-invite">
          <form class="invite-form" @submit.prevent="invite">
            <input v-model="email" type="text" name="email" placeholder="Email address">
            <input v-model="phone" type="tel" name="phone" placeholder="Phone #" @blur="phoneBlur" @focus="phoneFocus">
            <input v-model="name" type="text" name="name" placeholder="Name">

            <input type="submit" class="button" name="submit" value="Invite">
          </form>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import KidsPreview from '@/components/Kids/Preview'
import KidsNew from '@/components/Kids/New'

export default {
  name: 'Kids',
  data () {
    return {
      email: '',
      phone: '',
      name: ''
    }
  },

  computed: {
    // TODO think about using mapState for computed state
    // https://vuex.vuejs.org/guide/state.html#the-mapstate-helper
    kids () {
      return this.$store.state.kids.kids
    },

    showNewKid () {
      return this.$store.state.ui.showNewKid
    }
  },

  components: {
    KidsPreview,
    KidsNew
  },

  created () {
    this.$http.get('/children')
      .then(response => {
        this.$store.commit('setKids', response.data.children)
      })
      .catch(() => {
        console.log('failed to retrieve children')
      })
  },

  methods: {
    invite () {
      this.$http.post('/invites', { invite: {
        email: this.email,
        phone: this.phone,
        name: this.name
      }})
        .then(response => this.inviteSuccess(response))
        .catch(() => this.inviteFail())
    },

    inviteSuccess (response) {
      this.$store.commit('setError', {
        message: 'Invite sent!',
        type: 'success'
      })
      this.email = ''
      this.phone = ''
      this.name = ''
    },

    inviteFail () {
      this.$store.commit('setError', {
        message: 'Invite failed!',
        type: 'error'
      })
    },

    phoneBlur () {
      try {
        this.phone = this.$parsePhone.input(this.phone)
      } catch (e) {
        console.log(e)
      }
    },

    phoneFocus () {
      // TODO this is a little hacky, think about this a bit
      this.$parsePhone.reset()
    }
  }
}
</script>

<style scoped lang="css">
main {
  padding: 50px;
}

.kid-list {
  margin: 20px 0;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-around;
}

.invite-form {
  max-width: 500px;
  margin: auto;
}

@media screen and (max-width: 500px) {
  main {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Kids.vue